import { CurrentTimeContext } from '@context/CurrentTimeContext';
import { useContext } from 'react';

export function useCurrentTime() {
  const rerenderCounter = useContext(CurrentTimeContext);
  if (rerenderCounter === -1)
    throw new Error('Did you forget to utilize CurrentTimeProvider?');
  return new Date(); // new value on every rerender
}
